import { CDN_URL } from '../../utils/constants';
export class ProductCard {
    constructor(template, onClick) {
        this.template = template;
        this.onClick = onClick;
    }
    getCategoryClass(category) {
        const categoryMap = {
            'софт-скил': 'card__category_soft',
            'хард-скил': 'card__category_hard',
            'дополнительное': 'card__category_additional',
            'кнопка': 'card__category_button',
            'другое': 'card__category_other',
            'soft-skill': 'card__category_soft',
            'hard-skill': 'card__category_hard',
            'additional': 'card__category_additional',
            'button': 'card__category_button',
            'other': 'card__category_other'
        };
        return categoryMap[category.toLowerCase()] || 'card__category_other';
    }
    setElementText(element, text) {
        if (element) {
            element.textContent = text;
        }
    }
    setImage(element, src, alt) {
        if (element) {
            element.src = src.startsWith('http') ? src : `${CDN_URL}${src}`;
            element.alt = alt;
        }
    }
    render(product) {
        const card = this.template.content.firstElementChild.cloneNode(true);
        // Устанавливаем базовые свойства
        this.setElementText(card.querySelector('.card__title'), product.title || 'Без названия');
        this.setElementText(card.querySelector('.card__price'), product.price ? `${product.price} синапсов` : 'Бесценно');
        this.setImage(card.querySelector('.card__image'), product.image, product.title || '');
        // Обработка категории
        const categoryElement = card.querySelector('.card__category');
        if (categoryElement) {
            this.setElementText(categoryElement, product.category);
            categoryElement.className = 'card__category'; // Сбрасываем классы
            categoryElement.classList.add(this.getCategoryClass(product.category));
        }
        // Обработчик клика
        card.addEventListener('click', () => {
            this.onClick(product.id);
        });
        return card;
    }
    renderPreview(product) {
        const template = document.querySelector('#card-preview');
        const card = template.content.firstElementChild.cloneNode(true);
        // Устанавливаем базовые свойства
        const productName = product.title || 'Без названия';
        this.setElementText(card.querySelector('.card__title'), productName);
        this.setElementText(card.querySelector('.card__text'), product.description || '');
        this.setElementText(card.querySelector('.card__price'), product.price ? `${product.price} синапсов` : 'Бесценно');
        this.setImage(card.querySelector('.card__image'), product.image, productName);
        // Обработка категории
        const categoryElement = card.querySelector('.card__category');
        if (categoryElement) {
            this.setElementText(categoryElement, product.category);
            categoryElement.className = 'card__category'; // Сбрасываем классы
            categoryElement.classList.add(this.getCategoryClass(product.category));
        }
        // Удаляем кнопку для бесценных товаров
        if (product.price === null) {
            const buyButton = card.querySelector('.card__button');
            buyButton === null || buyButton === void 0 ? void 0 : buyButton.remove();
        }
        return card;
    }
}
